import type { BaseOptionType } from "antd/lib/select"

const SOURCE_LABELS_WITH_SOURCE_COMMENT = new Set([
  "referral",
  "other",
  "others",
  "other referral"
])

const OTHER_PREFIX = "other "

function normalizeSourceLabelPart(label: string): string {
  return String(label ?? "")
    .trim()
    .toLowerCase()
}

function sourceLabelNormalizedRequiresComment(
  normalizedLabel: string
): boolean {
  if (!normalizedLabel) return false
  if (SOURCE_LABELS_WITH_SOURCE_COMMENT.has(normalizedLabel)) return true
  return normalizedLabel.startsWith(OTHER_PREFIX)
}

export function isLeadSourceLabelRequiringComment(
  displayLabel: string | null | undefined
): boolean {
  return sourceLabelNormalizedRequiresComment(
    normalizeSourceLabelPart(displayLabel ?? "")
  )
}

export function isLeadSourceOtherReferral(
  sourceValue: string | null | undefined,
  sourceOptions: BaseOptionType[] | undefined
): boolean {
  if (sourceValue == null || sourceValue === "" || !sourceOptions?.length) {
    return false
  }
  const opt = sourceOptions.find((o) => o.value === sourceValue)
  const label = normalizeSourceLabelPart(String(opt?.label ?? ""))
  return sourceLabelNormalizedRequiresComment(label)
}
